import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._g(_vm._b({
    staticClass: "v-alert",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "role": "alert"
    }
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_vm.$slots.icon ? _c('div', {
    staticClass: "v-alert__icon"
  }, [_vm._t("icon")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-alert__content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('FlexSpacer'), _vm._v(" "), _vm.$slots.actions ? _c('div', {
    staticClass: "v-alert__actions"
  }, [_vm._t("actions")], 2) : _vm._e()], 1);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-814ef0be_0", {
    source: ".v-alert[data-v-814ef0be]{align-items:center;background:var(--c-bg-color);border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));color:var(--c-color);display:flex;font-size:.875rem;font-family:var(--g-font-body-family);line-height:1.4;margin:.25rem auto;padding:.75rem 1rem;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-alert__icon[data-v-814ef0be]{font-size:1.5rem;align-self:flex-start;margin-right:.625rem;line-height:1}.v-alert__icon svg[data-v-814ef0be]{vertical-align:top}.v-alert__actions[data-v-814ef0be]{margin-left:.75rem;margin-right:-.5rem}.v-alert__actions .v-button[data-v-814ef0be]{margin-bottom:0;margin-top:0}.v-alert--has-actions .v-alert__icon[data-v-814ef0be]{align-self:unset}.v-alert--outline[data-v-814ef0be]{background:0 0;border:.125rem solid var(--c-bg-color);color:var(--c-bg-color)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-814ef0be";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Alert = __vue_component__;
export { Alert as default };